import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { useHasRights } from "../../../contexts/UserRightsContext";
import Changes from "../../common/Changes";
import AgentHistory from "./AgentHistory";
import PlayerOnlineMessage from "./PlayerOnlineMessage";
import { toast } from "react-toastify";
import axios from "axios";

export default function GameModify(props) {
  //const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {},

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "100%",
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));

  const [isAgentHistory, setIsAgentHistory] = useState(false);
  const [isNewMessage, setIsNewMessage] = useState(false);
  const [password, setPassword] = useState(props.AgentInfo.password);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  useEffect(() => {
    setPassword(props.AgentInfo.password);
  }, [props.AgentInfo])

  const classes = useStyles();
  const handleCloseCharting = function () {
    setIsAgentHistory(false);
  };
  const handleCloseMessage = function () {
    setIsNewMessage(false);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  function Agent_ResePassword() {
    let AgentResetPasswordDTO = {
      IdAgent: props.AgentInfo.idAgent,
      Password: password,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Agent/Agent_ResePassword",
      data: AgentResetPasswordDTO,
    }).then((response) => {
      if (response.data === 0) {
        toast.success("Data Successfully Updated");
        props.getAgentInfo();
      }
      console.log("response", response);
    });
  }
  const canSeeHistory = useHasRights(27);

  return (
    <React.Fragment>
      <br />
      {isNewMessage ? (
        <PlayerOnlineMessage
          IdAgent={props.AgentInfo.idAgent}
          onClose={handleCloseMessage}
        />
      ) : (
        ""
      )}

      {isAgentHistory ? (
        <AgentHistory
          IdAgent={props.AgentInfo.idAgent}
          StartDate={"2020-05-01 00:00:00"}
          EndDate={"2020-05-07 00:00:00"}
          Filter={0}
          onClose={handleCloseCharting}
        />
      ) : (
        ""
      )}
      <h2 className="text-center">{props.AgentInfo.Agent}</h2>
      {props.AgentInfo && (
        <form className={`${classes.center} flex flex-col w-full gap-4`}>
          <div className="web-options">
            <TextField
              size="small"
              type="text"
              label="Agent"
              value={props.AgentInfo.agent}
              multiline={false}
              //onChange={handleChangeFamilyGame}
              variant="outlined"
            />
            <TextField
              size="small"
              type="text"
              label="Name"
              value={props.AgentInfo.name}
              multiline={false}
              //onChange={handleChangeFamilyGame}
              variant="outlined"
            />

            <Button
              hidden={!canSeeHistory}
              className={classes.button}
              variant="contained"
              onClick={() => {
                setIsAgentHistory(true);
              }}
            //startIcon={<SearchIcon />}
            >
              History
            </Button>
            <Changes
              title="Agent Changes"
              params={{
                ChangeType: 2,
                IdSport: "",
                Param1: props.AgentInfo.idAgent,
                Param2: 0,
                Param3: 0,
              }}
            />
          </div>
          <div className="web-options">
            <TextField
              size="small"
              type="text"
              label="Password"
              value={password}
              multiline={false}
              onChange={handlePasswordChange}
              variant="outlined"
            />

            <Button
              className={classes.button}
              variant="contained"
              onClick={() => {
                Agent_ResePassword();
              }}
            //startIcon={<SearchIcon />}
            >
              Reset Password
            </Button>

            <Button
              className={classes.button}
              variant="contained"
              onClick={() => {
                setIsNewMessage(true);
              }}
            //startIcon={<SearchIcon />}
            >
              New Online Msg
            </Button>
          </div>
        </form>
      )}
    </React.Fragment>
  );
}
